/* eslint-disable max-lines-per-function */
import { arbeitstage } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import { useTranslation } from 'react-i18next';
import z from 'zod';

export function useAbwesenheitenSchema() {
  const { t } = useTranslation();
  const AbwesenheitenAllgemeinSchema = z
    .object({
      anzahlUrlaubstage: z
        .string()
        .min(1, {
          error: t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.validationError',
          ),
        })
        .refine(
          (val) => {
            const rest = Math.abs(Number(val.replace(',', '.')) % 1);
            return rest === 0 || rest === 0.5;
          },
          {
            error: t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.validationErrorFormat',
            ),
          },
        ),
      anzahlArbeitstage: z
        .string()
        .optional()
        .refine((val) => val && Object.keys(arbeitstage).includes(val), {
          message: t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.validationError',
          ),
        }),
      stundenBewertung: z
        .enum(['fest', 'dynamisch'])
        .optional()
        .refine((val) => !!val, {
          message: t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.validationError',
          ),
        }),
      stunden: z.string().optional(),
    })
    .superRefine((data, ctx) => {
      if (data.stundenBewertung === 'fest' && !data.stunden) {
        ctx.addIssue({
          code: 'custom',
          message: t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.validationError',
          ),
          path: ['stunden'],
        });
      }
    });

  return {
    AbwesenheitenAllgemeinSchema,
  };
}
